<script>
import HomeStage from '~/components/blocks/HomeStage.vue';
import ItemSlider from '~/components/blocks/ItemSlider.vue';
import { compile, defineAsyncComponent } from 'vue';
import { useUserStore } from '~/stores/user.js';
import { mapStores } from 'pinia';

const SearchBar = defineAsyncComponent(() => import('~/components/SearchBar.vue'));
const ProductTile = defineAsyncComponent(() => import('~/components/ProductTile.vue'));
const ContentSliderTile = defineAsyncComponent(() => import('~/components/ContentSliderTile.vue'));
const RelatedProducts = defineAsyncComponent(() => import('~/components/blocks/RelatedProducts.vue'));
const ContactFormWrapper = defineAsyncComponent(() => import('~/components/blocks/ContactFormWrapper.vue'));
const SocialShare = defineAsyncComponent(() => import('~/components/blocks/SocialShare.vue'));
const AccordionContent = defineAsyncComponent(() => import('~/components/blocks/AccordionContent.vue'));
const EmbededPlayer = defineAsyncComponent(() => import('~/components/blocks/EmbededPlayer.vue'));
const DownloadResetForm = defineAsyncComponent(() => import('~/components/blocks/DownloadResetForm.vue'));
const LoadEmbeddedScript = defineAsyncComponent(() => import('~/components/LoadEmbeddedScript.vue'));

const ListPills = defineAsyncComponent(() => import('~/components/blocks/community/ListPills.vue'));
const FreeGuide = defineAsyncComponent(() => import('~/components/blocks/community/FreeGuide.vue'));
const CommunityHeader = defineAsyncComponent(() => import('~/components/blocks/community/CommunityHeader.vue'));
const BlogCategoryCarousel = defineAsyncComponent(() => import('~/components/blocks/community/BlogCategoryCarousel.vue'));
const CategoryLinks = defineAsyncComponent(() => import('~/components/blocks/community/CategoryLinks.vue'));
const IntroBox = defineAsyncComponent(() => import('~/components/blocks/IntroBox.vue'));
const RelatedPosts = defineAsyncComponent(() => import('~/components/blocks/RelatedPosts.vue'));
const ProductTiles = defineAsyncComponent(() => import('~/components/blocks/ProductTiles.vue'));
const BlogProductTile = defineAsyncComponent(() => import('~/components/blocks/BlogProductTile.vue'));
const DocumentDownloader = defineAsyncComponent(() => import('~/components/blocks/DocumentDownloader.vue'));
const DocumentEmbedder = defineAsyncComponent(() => import('~/components/blocks/DocumentEmbedder.vue'));
const NewsletterSignupTrigger = defineAsyncComponent(() => import('~/components/blocks/NewsletterSignupTrigger.vue'));

const Login = defineAsyncComponent(() => import('~/pages/login.vue'));

export default {
  props: [
      'content'
  ],
  components: {
    ProductTile,
    SearchBar,
    HomeStage,
    ItemSlider,
    ContentSliderTile,
    RelatedProducts,
    ContactFormWrapper,
    SocialShare,
    IntroBox,
    RelatedPosts,
    AccordionContent,
    EmbededPlayer,
    ProductTiles,
    BlogProductTile,
    DocumentDownloader,
    DocumentEmbedder,
    NewsletterSignupTrigger,
    DownloadResetForm,
    LoadEmbeddedScript,
    Login,

    // Community Pages
    CommunityHeader,
    ListPills,
    FreeGuide,
    BlogCategoryCarousel,
    CategoryLinks,
  },
  setup (props) {
    try {
      return compile(props.content, {
        isCustomElement: (tag) => ['swiper-container', 'swiper-slide', 'content', 'center'].includes(tag),
      });
    } catch (e) {
      return compile(`Error: ${e.toString()}`);
    }
  },
  computed: {
    isLoggedIn () {
      return !!this.userStore.user;
    },
    ...mapStores(useUserStore),
  }
};
</script>
